import { EndpointReponseProps } from "../types";

const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;
// const baseURL = "http://localhost:8080/api";

export const Endpoints = {
  GetCheckServerHealth: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/health`,
      method: "GET",
    };
  },
  GetLoginAdmin: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/login`,
      method: "POST",
    };
  },
  GetProfile: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/me`,
      method: "GET",
    };
  },

  /**
   * Patients
   */
  GetPatientsList: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/patients?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetPatientById: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/patients/${id}`,
      method: "GET",
    };
  },
  InvitePatient: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/patients/invite`,
      method: "POST",
    };
  },

  /**
   * Availability
   */
  GetAvailabilitiesList: (
    page: number,
    limit: number,
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/availability?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetAvailableDates: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/availability/available`,
      method: "GET",
    };
  },
  GetAvailabilityById: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/availability/${id}`,
      method: "GET",
    };
  },
  GetAvailabilityByDate: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/availability/date`,
      method: "GET",
    };
  },
  CreateAvailability: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/availability`,
      method: "POST",
    };
  },
  UpdateAvailability: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/availability/${id}`,
      method: "PUT",
    };
  },
  DeleteAvailability: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/availability/${id}`,
      method: "DELETE",
    };
  },
  CreateDateRangeAvailability: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/availability/range`,
      method: "POST",
    };
  },
  CreateRecurringAvailability: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/availability/recurring`,
      method: "POST",
    };
  },
  DeleteDateRangeAvailability: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/availability/range`,
      method: "DELETE",
    };
  },

  /**
   * Bookings
   */
  GetBookingsList: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/bookings?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetBookingById: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/bookings/${id}`,
      method: "GET",
    };
  },
  UpdateBookingStatus: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/bookings/${id}/status`,
      method: "PUT",
    };
  },
  DeleteBooking: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/bookings/${id}`,
      method: "DELETE",
    };
  },

  /**
   * Transactions
   */
  GetTransactionsList: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/transactions?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetTransactionById: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/transactions/${id}`,
      method: "GET",
    };
  },

  /**
   * Testimonials
   */
  GetTestimonialsList: (
    page: number,
    limit: number,
    status?: string,
  ): EndpointReponseProps => {
    let route = `${baseURL}/admin/testimonials?page=${page}&limit=${limit}`;
    if (status) {
      route += `&status=${status}`;
    }
    return {
      route,
      method: "GET",
    };
  },
  GetTestimonialById: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/testimonials/${id}`,
      method: "GET",
    };
  },
  UpdateTestimonialStatus: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/testimonials/${id}/status`,
      method: "PUT",
    };
  },
  DeleteTestimonial: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/testimonials/${id}`,
      method: "DELETE",
    };
  },

  /**
   * Refunds
   */
  GetCancelledBookings: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/bookings/cancelled?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  ProcessRefund: (bookingId: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/payments/refund/${bookingId}`,
      method: "POST",
    };
  },

  /**
   * Consultations
   */
  CreateConsultation: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/consultations`,
      method: "POST",
    };
  },
  GetConsultationsList: (
    page: number,
    limit: number,
    patientId?: string,
  ): EndpointReponseProps => {
    let route = `${baseURL}/admin/consultations?page=${page}&limit=${limit}`;
    if (patientId) {
      route += `&patientId=${patientId}`;
    }
    return {
      route,
      method: "GET",
    };
  },
  GetConsultationById: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/consultations/${id}`,
      method: "GET",
    };
  },
  GetConsultationsByPatientId: (
    patientId: string,
    page: number,
    limit: number,
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/consultations/patient/${patientId}?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  UpdateConsultation: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/consultations/${id}`,
      method: "PUT",
    };
  },
  GetVisitorStats: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/analytics/stats`,
      method: "GET",
    };
  },
  /**
   * Tips
   */
  GetTipsList: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/tips?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetTipById: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/tips/${id}`,
      method: "GET",
    };
  },
  CreateTip: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/tips`,
      method: "POST",
    };
  },
  UpdateTip: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/tips/${id}`,
      method: "PUT",
    };
  },
  DeleteTip: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/tips/${id}`,
      method: "DELETE",
    };
  },
  /**
   * Upload
   */
  UploadImage: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/upload/image`,
      method: "POST",
    };
  },
  /**
   * Newsletter
   */
  GetSubscribersList: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/newsletter/all?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  BroadcastNewsletter: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/newsletter/broadcast`,
      method: "POST",
    };
  },
  GetSentEmailsList: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/newsletter/emails/all?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },

  /**
   * U-WIP memberships
   */
  GetUwipMemberships: (
    page: number,
    limit: number,
    status?: string
  ): EndpointReponseProps => {
    let route = `${baseURL}/admin/uwip/memberships?page=${page}&limit=${limit}`;
    if (status) {
      route += `&status=${encodeURIComponent(status)}`;
    }
    return {
      route,
      method: "GET",
    };
  },
  GetUwipMembershipById: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/uwip/memberships/${id}`,
      method: "GET",
    };
  },
  CancelUwipMembership: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/uwip/memberships/${id}/cancel`,
      method: "POST",
    };
  },
  MarkUwipZellePaid: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/uwip/memberships/${id}/mark-zelle-paid`,
      method: "POST",
    };
  },
};
